/**
 * Carousels Module
 * Handles all Swiper carousel initializations
 */

import { createSwiperWithPreset } from "../utils/swiperConfig.js";
import { $, exists, closest } from "../utils/dom.js";

export const initLogoCarousel = () => {
  if (exists(".logo-carousel__swiper")) {
    const logoCarouselswiper = createSwiperWithPreset(
      ".logo-carousel__swiper",
      "logoCarousel",
      {
        navigation: {
          nextEl: ".logo-carousel__nav--next",
          prevEl: ".logo-carousel__nav--prev",
        },
      },
    );

    // let swiperPosition = 0;
    // const swiperElement = $(".logo-carousel__swiper");
    // const container = closest(swiperElement, ".container") || swiperElement.parentElement;

    // if (container) {
    //   container.addEventListener("mouseenter", function () {
    //     if (logoCarouselswiper && logoCarouselswiper.autoplay) {
    //       swiperPosition = logoCarouselswiper.getTranslate();
    //       logoCarouselswiper.autoplay.pause();
    //       logoCarouselswiper.setProgress(0, 0);
    //       logoCarouselswiper.setTranslate(swiperPosition);
    //     }
    //   });

    //   container.addEventListener("mouseleave", function () {
    //     if (logoCarouselswiper && logoCarouselswiper.autoplay) {
    //       logoCarouselswiper.autoplay.resume();
    //       logoCarouselswiper.update();
    //       logoCarouselswiper.setTranslate(swiperPosition);
    //     }
    //   });
    // }
  }
};

export const initCardImageSlider = () => {
  if (exists(".card-image-slider__swiper")) {
    const cardImageSlider = createSwiperWithPreset(
      ".card-image-slider__swiper",
      "standardCarousel",
      {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".card-image-slider__next",
          prevEl: ".card-image-slider__prev",
        },
      },
    );
  }
};

export const initFocusModuleSlider = () => {
  if (exists(".focus-module-slider__swiper")) {
    const focusModuleSlider = createSwiperWithPreset(
      ".focus-module-slider__swiper",
      "standardCarousel",
      {
        navigation: {
          nextEl: ".focus-module-slider__next",
          prevEl: ".focus-module-slider__prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2, // Mostra 20% della slide successiva su mobile
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 2.2, // Mostra 20% della slide successiva su tablet
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      },
    );
  }
};

export const initEditorialModuleSlider = () => {
  if (exists(".editorial-card-module__swiper")) {
    const editorialModuleSlider = createSwiperWithPreset(
      ".editorial-card-module__swiper",
      "standardCarousel",
      {
        navigation: {
          nextEl: ".editorial-card-module__next",
          prevEl: ".editorial-card-module__prev",
        },
      },
    );
  }
};

export const initSideContentStoriesSlider = () => {
  if (exists(".side-content-stories-slider__swiper")) {
    const sideContentStoriesSlider = createSwiperWithPreset(
      ".side-content-stories-slider__swiper",
      "singleSlide",
      {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".side-content-stories-slider__next",
          prevEl: ".side-content-stories-slider__prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1, // Mostra 10% della slide successiva su mobile
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
    );
  }
};

export const initTimelineSlider = () => {
  if (exists(".timeline-slider__swiper")) {
    const timelineSlider = createSwiperWithPreset(
      ".timeline-slider__swiper",
      "timelineSlider",
    );
  }
};
